<template lang="pug">
  div(:class="position")
    span {{ digit }}
</template>

<script>
  export default {
    name: "StaticCard",
    props: {
      position: {
        type: String,
        required: true
      },
      digit: {
        required: true
      }
    }
  }
</script>

<style scoped lang="scss">

</style>